export const CHARGE_STATUS = [
  { id: 'Select all', name: 'Select all' },
  { id: 'Pending', name: 'Pending' },
  { id: 'Paid', name: 'Paid' },
  { id: 'Failed', name: 'Failed' }
];
